import { Text } from "@skailer-com/uikit";

interface FieldHintProps {
  hint?: string | null;
}

export function FieldHint({ hint }: FieldHintProps) {
  if (!hint?.trim()) return null;

  return <Text className="text-sm text-secondary whitespace-pre-wrap">{hint}</Text>;
}
